
export default {
    props: {
        pagination: {
            type: Object,
            required: true
        }
    },
    methods: {
        test (link) {
            const match = link.url.match(/\d+/)
            if (match !== null) {
                this.$emit('page', match[0])
            }
        }
    }
}
